<template lang="pug">
    v-layout(row wrap)
        v-flex(md8)
            //- payment-method
            //- payment-details
            payment-comp( 
                @success='$emit("success")'
                :copies='copies' 
                :saleCreditNotes='saleCreditNotes' 
                @goback='$emit("goback")' 
                )
        v-flex(md4)
            payment-information()
        v-flex(md8)
            //- payment-details
</template>

<script>
import PaymentMethod from './paymentMethod/PaymentMethod'
import PaymentInformation from './detail/SaleInformation'
import PaymentDetails from './detail/PaymentDetails'
import PaymentComp from './Payment'
export default {
    name: 'component-name',
    props: {
        saleCreditNotes: {
            type: Array,
            default: () => [],
        },
        copies: {
            type: Number,
            default: 1,
        },
    },
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {
        'payment-method':PaymentMethod,
        'payment-information': PaymentInformation,
        'payment-details': PaymentDetails,
        'payment-comp' : PaymentComp,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>